import React, { Component } from 'react';
import { Modal, Radio, message, DatePicker } from 'antd';
import ExportUtil from '../../../../common/ExportUtil';
import FormList from '../../../basicElement/FormList';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';
import moment from 'moment';

const RadioGroup = Radio.Group;
const dateFormat = 'YYYY-MM-DD';
const { MonthPicker } = DatePicker;

class SetRecord extends Component {
    state = {
        visible: false,
        loading: false,
    }

    show = (groupRecordMode) => {
        this.setState({
            visible: true,
            groupRecordMode,
        });
    }

    handleOk = () => {
        const { groupRecordMode } = this.state;
        if (!groupRecordMode) {
            message.warning('设置入组情况记录方式');
            return;
        }
        const { invId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.addGroupRecordMode,
            data: {
                groupRecordMode,
                investigationId: invId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.success) {
                    message.success(res.success);
                }
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ groupRecordMode: e.target.value });
    }

    render () {
        const { visible, groupRecordMode, loading } = this.state;
        return (
            <Modal
                title="设置入组情况记录方式"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                maskClosable={false}
                width="500px"
                confirmLoading={loading}
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label" style={{width:130}}>入组情况记录方式</label>
                            </div>
                            <div className="item" style={{ width: '65%' }}>
                                <RadioGroup onChange={this.onChange} value={groupRecordMode}>
                                    <Radio value="WEEK">按周记录</Radio>
                                    <Radio value="MONTH">按月记录</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

class RegisterLPI extends React.Component {
    state = {
        params: {},
        visible: false,
        loading: false,
    }
    
    show = (record = {}) => {
        this.setState({
            visible: true,
            params: { ...record },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params: { lpiTime, competingCompanyManifestationId } } = this.state;
        if (!lpiTime) {
            message.warning('请选择LPI');
            return;
        }
        this.setState({ loading: true });
        const options = {
            url: API_URL.competeCompany.addCompetingCompanyLPI,
            data: {
                competingCompanyManifestationId,
                lpiTime: lpiTime.slice(0, 10),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    onChange = (date, dateString) => {
        const { params } = this.state;
        params.lpiTime = dateString;
        this.setState({ params });
    }

    render () {
        const { visible, loading, params: { lpiTime } } = this.state;
        const newLpiTime = lpiTime ? moment(lpiTime) : null;
        return (
            <Modal
                title="登记LPI"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="create-modal"
                maskClosable={false}
                width="400px"
                confirmLoading={loading}
            >
                <div className="filter-bar" style={{ marginTop: 10 }}>
                    <div className="filter-bar-investigation">                    
                        <div className="form-item">
                            <label htmlFor="" className="ui-label" style={{ paddingLeft: 60 }}>LPI</label>
                            <DatePicker
                                placeholder="请选择"
                                style={{width: 160}}
                                allowClear={true}
                                value={newLpiTime}
                                format={dateFormat}
                                onChange={this.onChange}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

class RegisterStartUp extends Component {
    state = {
        data: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            visible: true,
            data: {
                siteIsStart: '0',
                ...record,
            },
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        data[key] = value;
        if (key == 'siteIsStart') {
            if (value == 0) {
                data.projectApprovalTime = '';
                data.beginTime = '';
            }
        }
        this.setState({
            data,
            hasEdit: true,
        });
    }

    getColumns = () => {
        const { data } = this.state;
        const { siteIsStart } = data;

        // 字段属性配置
        const columns = [{
            name: '中心是否已启动',
            key: 'siteIsStart',
            type: 'radio',
            typeProperty: {
                list: [{ label: '是', value: '1' }, { label: '否', value: '0' }],
            },
            rules: {
                required: true,
            }
        },  {
            name: '递交立项资料时间',
            key: 'projectApprovalTime',
            type: 'datePicker',
            typeProperty: {
                style: { width: 160 },
                disabled: siteIsStart != 1,
            },
        }, {
            name: '启动时间',
            key: 'beginTime',
            type: 'datePicker',
            typeProperty: {
                style: { width: 160 },
                disabled: siteIsStart != 1,
            },
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = true;
                    typeProperty.value = data[key];
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        const { competingCompanyManifestationId, siteIsStart, beginTime, projectApprovalTime } = data;
        const params = {};
        if (siteIsStart == 1) {
            params.beginTime = beginTime ? beginTime.slice(0, 10) : '';
            params.projectApprovalTime = projectApprovalTime ? projectApprovalTime.slice(0, 10) : '';
        } else {
            params.beginTime = '';
            params.projectApprovalTime = '';
        }

        this.setState({ loading: true });
            const options = {
                method: 'POST',
                url: API_URL.competeCompany.addRegistrationStart,
                data: {
                    siteIsStart,
                    competingCompanyManifestationId,
                    ...params,
                },
                dataType: 'json',
                doneResult: res => {
                    if (res.success) {
                        message.success(res.success);
                    }
                    this.setState({
                        visible: false,
                        loading: false,
                    }, () => {
                        this.props.loadData();
                    });
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            }
            $.sendRequest(options);
    }

    render() {
        const { loading, visible, data } = this.state;
        const { companyName, hospitalName, departmentLocalName } = data;
        return (
            <Modal
                title="登记启动情况"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                maskClosable={false}
                width="400px"
                confirmLoading={loading}
            >
                <div style={{ padding: '10px 20px' }}>
                    公司名称：{companyName}
                    <span className="ant-divider" />
                    医院名称：{hospitalName}
                    <span className="ant-divider" />
                    科室：{departmentLocalName}
                </div>
                <div style={{ margin: '10px 0' }}>
                    <FormList
                        className="form-list registerStartUp-list"
                        columns={this.getColumns()}
                        onChange={this.handleChange}
                        ref={el => this.formRef = el}
                    />
                </div>
            </Modal>
        );
    }
}

class ExportModal extends Component {
    state = {
        data: {},
        visible: false,
    }

    show = (data) => {
        this.setState({
            data,
            visible: true,
        });
    }

    handleOk = () => {
        const { data } = this.state;
        if (!data.exportType) {
            message.warning('请选择要导出内容');
            return;
        }

        const url = API_URL.competeCompany.exportCompeteCompanyList;
      
        ExportUtil.export(data, null, url);
        this.cancel();
    }

    cancel = () => {
        this.setState({ visible: false });
    }

    handleChange = (e, key) => {
        const { data } = this.state;
        data[key] = e.target.value;
        this.setState({ data });
    }

    render () {
        const { visible, data: { exportType } } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.cancel}
                className="create-modal"
                maskClosable={false}
                width="400px"
            >
                <div className="cont-cont" style={{ padding: 20 }}>
                    <div className="item" >
                        <label className="ui-label">请选择竞争公司表现的导出方式：</label>
                    </div>
                    <div className="item">
                        <RadioGroup onChange={e => this.handleChange(e, 'exportType')} value={exportType}>
                            <div style={{marginTop:15}}><Radio value="TOTAL">导出汇总数据</Radio></div>
                            <div style={{marginTop:15}}><Radio value="DETAIL">导出明细数据</Radio></div>
                        </RadioGroup>
                    </div>
                </div>
            </Modal>
        )
    }
}

export { SetRecord, RegisterLPI, RegisterStartUp, ExportModal };


// WEBPACK FOOTER //
// ./src/components/competeCompany/Performance/components/PreviewModal.js